module.exports = __webpack_public_path__ + "img/blueRadio.c79c2bbd.svg";